/**
 * @module cercaliagl/view/VStreetView
 */

import $ from 'jquery';
import BaseView from './BaseView';
import { createIconButton } from './VUtils';

/**
 * @enum {string}
 */
export const EventType = {
  CLOSE: 'close',
};
/**
 * @classdesc
 */
class VStreetView extends BaseView {
  /**
   * @constructor
   */
  constructor(options = {}) {
    const jqElement = $(`
    <div class="street-view-dialog mdc-elevation--z4">
      <div class="header">
        <span>${'Google maps - Street View'}</span>
        <div class="closeBtn">
        ${createIconButton('closeBtn', null, 'close')}
      </div>
      </div>
    </div>
    `);

    super(jqElement);

    /**
     * @private
     * @type {number}
     */
    this.width = options.width ? options.width : 600;

    /**
     * @private
     * @type {number}
     */
    this.height = options.height ? options.height : 480;

    jqElement.css('width', this.width);
    jqElement.css('height', this.height);
    jqElement.find('button.closeBtn').click(() => this.emit(EventType.CLOSE));

    this.makePopupDraggable(jqElement);
  }

  /**
   * @private
   */
  // eslint-disable-next-line class-methods-use-this
  makePopupDraggable(jqElement) {
    const header = jqElement.find('.header');

    header.on('mousedown', (e) => {
      e.preventDefault();

      const startX = e.clientX;
      const startY = e.clientY;

      // Calcula el desplazamiento inicial en relación a la posición del documento
      const initialOffset = jqElement.offset();
      function mouseMoveHandler(mouseEvent) {
        const newLeft = mouseEvent.clientX - startX + initialOffset.left;
        const newTop = mouseEvent.clientY - startY + initialOffset.top;
        jqElement.offset({
          left: newLeft,
          top: newTop,
        });
      }

      $(document).on('mousemove', mouseMoveHandler);
      $(document).on('mouseup', () => {
        $(document).off('mousemove', mouseMoveHandler);
      });
    });
  }
}

export default VStreetView;
